import { render, staticRenderFns } from "./AssistantEdit.vue?vue&type=template&id=0b9f7b54&"
import script from "./AssistantEdit.vue?vue&type=script&lang=js&"
export * from "./AssistantEdit.vue?vue&type=script&lang=js&"
import style0 from "./AssistantEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports